import React, { useState } from "react";
import Backdrop from "../../../../UI/Backdrop";

const DeleteReasonModal = ({ onSubmit, onCancel }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Reason is required");
      return;
    }

    onSubmit(reason);
  };

  return (
    <>
      <Backdrop />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[9999] min-w-[450px] bg-white rounded-[15px] px-5 py-8">
        <h2 className="font-ubuntu font-bold text-center mb-4">
          Reason for Deletion
        </h2>

        <textarea
          rows="4"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Please tell us why you want to delete your account"
          className="w-full border rounded-lg p-3 outline-none focus:border-[#F77611]"
        />

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

        <div className="flex space-x-5 justify-center mt-6">
          <button
            onClick={handleSubmit}
            className="px-4 bg-[#FFDBB0] text-[#F77611] font-ubuntu font-bold py-2 rounded-full min-w-[120px]"
          >
            Submit
          </button>

          <button
            onClick={onCancel}
            className="px-4 bg-[#FFDBB0] text-[#F77611] font-ubuntu font-bold py-2 rounded-full min-w-[120px]"
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteReasonModal;
